import { AuditTemplate } from '../auditTypes';
import { q } from './q';

export const WEEKLY: AuditTemplate[] = [
  {
    id: 'weekly-hs', name: 'Weekly Health and Safety Check', frequency: 'weekly',
    description: 'Fire, equipment, water safety, premises - Reg 15 and Reg 12.',
    questions: [
      q('hs01', 'Fire alarm tested this week and logged; panel fault free or faults actioned.', 'safe', 'Reg 15', true),
      q('hs02', 'Extinguishers in place, accessible, in date, pins and seals intact; fire blanket in kitchen.', 'safe', 'Reg 15'),
      q('hs03', 'First aid kits stocked and in date; accident book present and in use.', 'safe'),
      q('hs04', 'COSHH: substances labelled, safety sheets available, locked storage, staff aware.', 'safe'),
      q('hs05', 'Hoists and slings visual check; LOLER and PUWER inspections within 6 months.', 'safe', 'Reg 15', true),
      q('hs06', 'Wheelchairs: brakes, tyres, cushions checked; maintenance log signed.', 'safe'),
      q('hs07', 'No damaged plugs, cables or sockets; PAT labels in date.', 'safe'),
      q('hs08', 'Certificates in date: gas annual, electrical, boiler service, kitchen extraction.', 'safe', 'Reg 15', true),
      q('hs09', 'Legionella: hot 50C or above at return, cold below 20C at sentinel outlets; weekly temps logged; TMVs at or below 41C at baths.', 'safe', 'Reg 15'),
      q('hs10', 'Bed rails, restrictors, window restrictors risk assessed; no unassessed restraint.', 'safe', 'Reg 12', true),
      q('hs11', 'External areas safe: paths, lighting, gates, sheds locked, chemicals secured.', 'safe'),
      q('hs12', 'Signage adequate: fire action notices, dementia friendly room signage, wayfinding.', 'responsive'),
      q('hs13', 'Security: door alarms working, external doors secure, visitor sign in use.', 'safe'),
      q('hs14', 'Emergency lighting visually OK; monthly flick test logged when due.', 'safe'),
    ],
  },
  {
    id: 'weekly-ipc-deep', name: 'Weekly IPC Deep Audit', frequency: 'weekly',
    description: 'Beyond the daily check - systems, stocks, knowledge.',
    questions: [
      q('wd01', 'Clinical and food fridges cleaned and defrosted to schedule.', 'safe'),
      q('wd02', 'Sluice and macerator functioning; no blockages or splashing risk.', 'safe'),
      q('wd03', 'PPE stock holds at least two weeks buffer.', 'safe'),
      q('wd04', 'Cleaning equipment colour coded, good condition, replaced to schedule.', 'safe'),
      q('wd05', 'Isolation room ready and stocked.', 'safe'),
      q('wd06', 'Ask one staff member the outbreak actions; answer correct.', 'wellled'),
      q('wd07', 'Unused showers and rooms flushed or cleaned to water hygiene plan.', 'safe'),
      q('wd08', 'Observe one care task end to end for IPC compliance.', 'safe', 'Reg 12'),
    ],
  },
  {
    id: 'weekly-activities', name: 'Weekly Activities and Wellbeing Audit', frequency: 'weekly',
    description: 'Responsive key question - a life, not just care.',
    questions: [
      q('ac01', 'Seven day programme displayed, varied: physical, cognitive, social, spiritual.', 'responsive', 'Reg 9'),
      q('ac02', 'Participation recorded; choices reflect assessed preferences and life story.', 'responsive'),
      q('ac03', 'Residents observed engaged and enjoying; decliners gently re-offered alternatives.', 'caring'),
      q('ac04', 'One to one sessions happening for residents who cannot join groups.', 'responsive'),
      q('ac05', 'Activities respect culture, religion, sexuality, former occupation.', 'responsive', 'Reg 9'),
      q('ac06', 'Garden and outdoor access facilitated safely.', 'responsive'),
      q('ac07', 'Resident and relative feedback on activities sought and acted on.', 'responsive'),
    ],
  },
  {
    id: 'weekly-nutrition', name: 'Weekly Menu and Nutrition Audit', frequency: 'weekly',
    description: 'Reg 14 nutrition and hydration done properly.',
    questions: [
      q('nu01', 'Four week rotating menu with seasonal options; residents consulted on changes.', 'responsive', 'Reg 14'),
      q('nu02', 'Mealtime observation: help timely, staff sit at eye level, unhurried.', 'caring', 'Reg 14'),
      q('nu03', 'MUST scores current; weights recorded to plan; dietitian referrals actioned.', 'effective', 'Reg 14'),
      q('nu04', 'Texture modified meals prepared to IDDSI and presented with dignity.', 'effective', 'Reg 14', true),
      q('nu05', 'Fortified diet and fluid charts in use for at-risk residents.', 'effective'),
      q('nu06', 'Dining environment: tables laid, calm, company, no clinical clutter.', 'caring'),
      q('nu07', 'Snacks and drinks offered between meals and recorded.', 'effective', 'Reg 14'),
      q('nu08', 'Cultural, religious and personal preferences met.', 'responsive', 'Reg 9'),
    ],
  },
];